import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { Dropdown, Flex, Icon, IconProps } from '@gaiads/telia-react-component-library';
import { HTMLElementProps } from '../../../utils/types';

import { BaseEditableItemFieldProps } from '../EditableItem';
import EditableItemIcons, { EditableItemIconsProps } from '../EditableItemIcons/EditableItemIcons';

export interface EditableItemDropdownProps extends BaseEditableItemFieldProps, EditableItemIconsProps {
  edit?: boolean;
  onSave?: () => Promise<boolean>;
  onBlur?: () => void;
  flexProps?: Partial<React.ComponentProps<typeof Flex> & HTMLElementProps>;
  iconsFlexProps?: Partial<React.ComponentProps<typeof Flex> & HTMLElementProps>;
  dropdownProps: React.ComponentProps<typeof Dropdown> & HTMLElementProps;
  saveIconProps?: Partial<IconProps & HTMLElementProps>;
}

export default function EditableItemDropdown(props: EditableItemDropdownProps) {
  const {
    edit = true,
    onSave,
    onBlur,
    isEditingItem,
    setIsEditingItem,
    showSave,
    showDelete,
    onDelete,
    flexProps,
    iconsFlexProps,
    dropdownProps,
    saveIconProps,
    editIconProps,
    deleteIconProps,
  } = props;

  const { t } = useTranslation('editableItem');

  const handleKeyPress = (event: React.KeyboardEvent<HTMLInputElement>) => {
    if (event.key === 'Escape') {
      onBlur?.();
      setIsEditingItem?.(false);
    }
  };

  useEffect(() => {
    if (edit) {
      setIsEditingItem?.(true);
    }
  }, [edit, setIsEditingItem]);

  const handleSave = async () => {
    const success = await onSave?.();
    setIsEditingItem?.(!success);
  };

  return (
    <Flex centeredVertically {...flexProps} className={['editable-field__field', flexProps?.className]}>
      {isEditingItem ? (
        <>
          <Dropdown
            onKeyDown={handleKeyPress}
            //onBlur={() => setIsEditingItem?.(false)}
            {...dropdownProps}
          />
          {showSave && (
            <Icon
              title={t('titles.save')}
              name="checkmark"
              size="sm"
              margin={{ size: 'sm' }}
              onClick={() => handleSave()}
              clickableAppearance
              {...saveIconProps}
            />
          )}
        </>
      ) : (
        dropdownProps.selectedOption?.label || dropdownProps.placeholder
      )}
      {!isEditingItem && (
        <EditableItemIcons
          showDelete={showDelete}
          onDelete={onDelete}
          setIsEditing={isEditing => setIsEditingItem?.(isEditing)}
          flexProps={iconsFlexProps}
          editIconProps={editIconProps}
          deleteIconProps={deleteIconProps}
        />
      )}
    </Flex>
  );
}
